import React from 'react';
import style from './index.scss';

/**
 * SupervisorReviewWidget component
 */
export class SupervisorReviewWidget extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.APPROVE = 'approve';
    this.REJECT = 'reject';
    this.state = {
      permissionConfig: {}
    };
  }

  /**
   * componentWillReceiveProps
   * @param nextProps
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps?.permissionConfig) {
      this.setState({ permissionConfig: nextProps.permissionConfig });
    }
  }

  /**
   * onApproveReject
   * @param status
   */
  onApproveReject = (status) => {
    this.props.onAnomalyStatusChange(status);
  };

  /**
   * render
   * @returns {*}
   */
  render() {
    const { permissionConfig } = this.state;
    const { isDisabled, isHidden } = permissionConfig || {};
    if (isHidden) {
      return <div />;
    }

    return (
      <div className={style.flexRow}>
        <button
          disabled={isDisabled}
          onClick={() => {
            this.onApproveReject(this.REJECT);
          }}
          className={style.primaryButton}
          type="button">
          Reject
        </button>
        <button
          disabled={isDisabled}
          onClick={() => {
            this.onApproveReject(this.APPROVE);
          }}
          className={style.secondaryButton}
          type="button">
          Approve
        </button>
      </div>
    );
  }
}
